module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    attrs: {
      "start": _vm.start
    }
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      staticClass: "list-item"
    }, [(_vm.isShortUrl(post.url)) ? _c('router-link', {
      staticClass: "post-title",
      attrs: {
        "to": {
          name: 'commentsList',
          params: {
            id: post.id
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(post.title) + "\n    ")]) : _c('a', {
      staticClass: "post-title",
      attrs: {
        "href": post.url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v("\n      " + _vm._s(post.title) + "\n    ")]), _vm._v(" "), (post.domain) ? _c('span', {
      staticClass: "txt-grey"
    }, [_vm._v("\n      (" + _vm._s(post.domain) + ")\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "txt-grey"
    }, [(post.points !== null) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.pluralize(post.points, 'point')) + "\n      ")]) : _vm._e(), _vm._v(" "), (post.user) ? _c('span', [_vm._v("by "), _c('b', [_vm._v(_vm._s(post.user))])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(post.time_ago) + " |")]), _vm._v(" "), _c('router-link', {
      staticClass: "comment-link",
      attrs: {
        "to": {
          name: 'commentsList',
          params: {
            id: post.id
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.pluralize(post.comments_count, 'comment')) + "\n      ")])], 1)], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24b31533","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostsList.vue
// module id = 34
// module chunks = 0